// Pounce appointments ki list aur detail dono ke kaam ke chhote helpers.

export const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

// Hafta Monday se shuru (design ka "Mar 10 - Mar 16" Mon–Sun hai).
export const startOfWeek = (date) => {
  const d = new Date(date);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  d.setHours(0, 0, 0, 0);
  return d;
};

const monthDay = (d) => d.toLocaleDateString("en-US", { month: "short", day: "numeric" });

// "Mar 10 - Mar 16, 2025"
export const formatRange = (from, to) => `${monthDay(from)} - ${monthDay(to)}, ${to.getFullYear()}`;

// `timeZone` (IANA, jaise "America/New_York") = appointment ka apna timezone.
// Diya ho to waqt usi me dikhta hai — wahi jo lead ko bataya gaya tha — chahe
// dekhne wala kahin bhi ho. Na ho to dekhne wale ka local.
const zone = (timeZone) => (timeZone ? { timeZone } : {});

// "Tue, Mar 11, 2025"
export const formatDay = (iso, timeZone) =>
  new Date(iso).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    ...zone(timeZone),
  });

// "2:00 PM"
export const formatTime = (date, timeZone) =>
  new Date(date).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", ...zone(timeZone) });

// "2:00 PM – 2:30 PM"
export const formatTimeRange = (iso, minutes, timeZone) => {
  const start = new Date(iso);
  return `${formatTime(start, timeZone)} – ${formatTime(new Date(start.getTime() + minutes * 60000), timeZone)}`;
};

// "Mar 10, 2025 · 10:24 AM"
export const formatStamp = (iso) =>
  `${new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} · ${formatTime(iso)}`;

export const initials = (text) =>
  String(text || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

// Card / detail ka status chip. `tone` = CSS class ka naam (dono module CSS me).
export const getBadge = (appt) => {
  if (appt.status === "completed") return { label: "Completed", tone: "badgeSuccess", icon: "check" };
  if (appt.status === "cancelled") {
    // Kisne cancel kiya — backend ye abhi nahi batata; pata ho tabhi likho.
    const by = { business: " by Business", lead: " by Lead" }[appt.cancelledBy] || "";
    return {
      label: `Cancelled${by}`,
      tone: "badgeDanger",
      icon: "cross",
    };
  }
  if (appt.rescheduled) return { label: "Rescheduled", tone: "badgeWarning", icon: "refresh" };
  // 24 ghante ke andar wali meeting.
  const msAway = new Date(appt.startTime) - Date.now();
  if (msAway > 0 && msAway <= 24 * 60 * 60 * 1000) {
    return { label: "Starting Soon", tone: "badgeBrand", icon: "clock" };
  }
  return { label: "Upcoming", tone: "badgeBrand", icon: "clock" };
};
